var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "900" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _vm.step == 2
                ? _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", loading: _vm.loading },
                      on: { click: _vm.enviar }
                    },
                    [_vm._v(" Enviar ")]
                  )
                : _vm._e(),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Enviar" } }),
      _c("p", [
        _vm._v(
          " Você está compatilhando a tela " +
            _vm._s(_vm.pagesNames[_vm.pageName]) +
            ", para cliente " +
            _vm._s(_vm.cliente ? _vm.cliente.name : _vm.$currentClient().name) +
            " "
        )
      ]),
      _c(
        "div",
        [
          _c(
            "v-stepper",
            {
              staticClass: "elevation-0",
              model: {
                value: _vm.step,
                callback: function($$v) {
                  _vm.step = $$v
                },
                expression: "step"
              }
            },
            [
              _c(
                "v-stepper-header",
                { attrs: { hidden: "" } },
                [
                  _c("v-stepper-step", { attrs: { step: "1" } }, [
                    _vm._v("Lista de salas")
                  ]),
                  _c("v-stepper-step", { attrs: { step: "2" } }, [
                    _vm._v("Mensagens")
                  ])
                ],
                1
              ),
              _c(
                "v-stepper-items",
                [
                  _c(
                    "v-stepper-content",
                    { attrs: { step: "1" } },
                    [
                      _c("v-data-table", {
                        staticClass: "row-pointer",
                        attrs: {
                          items: _vm.$store.getters["chat/rooms"],
                          headers: _vm.headers,
                          height: "300",
                          "fixed-header": ""
                        },
                        on: { "click:row": _vm.selectRoom },
                        scopedSlots: _vm._u([
                          {
                            key: "no-data",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "mt-5" },
                                  [
                                    _c("p", [
                                      _vm._v("Nenhum canal encontrado")
                                    ]),
                                    _c(
                                      "BaseButton",
                                      {
                                        attrs: { small: "", primary: "" },
                                        on: { click: _vm.openCreate }
                                      },
                                      [
                                        _c("strong", [_vm._v("+")]),
                                        _vm._v(" Canal ")
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "item.participantes",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(item.participantes.join(", ")) +
                                    " "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-content",
                    { attrs: { step: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Mensagem" },
                        model: {
                          value: _vm.message_text,
                          callback: function($$v) {
                            _vm.message_text = $$v
                          },
                          expression: "message_text"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }